import React from 'react';

function PageNotFound() {
  return <h1 style={{ textAlign: 'center', marginTop: 40 }}>Page not found</h1>;
}

export default PageNotFound;
